import {JsonObject, JsonProperty} from "json2typescript";

import {JsonPropertyEmpty} from "../../utils/json-util";

@JsonObject("TemplateColumnListDetailItemOutput")
export class TemplateColumnListDetailItemOutput {
    @JsonProperty()
    public id: string = "";

    @JsonProperty()
    public slug: string = "";

    @JsonProperty()
    public label: string = "";

    @JsonProperty()
    public type: "STRING" | "IMAGE" = "STRING";

    @JsonProperty()
    public note: string = "";

    @JsonProperty()
    public deleted: boolean = false;
}

@JsonObject("TemplateDetailOutput")
export class TemplateDetailOutput {
    @JsonProperty()
    public id: string = "";

    @JsonProperty()
    public title: string = "";

    @JsonProperty()
    public note: string = "";

    @JsonProperty()
    public createdUserName: string = "";

    @JsonProperty()
    public createdAt: string = "";

    @JsonProperty()
    public deleted: boolean = false;
    @JsonProperty()
    public templateColumnList: TemplateColumnListDetailItemOutput[] = JsonPropertyEmpty;
}
